import type { ConceptDef } from '../types';

export const receptiveActions: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-actions',
  label: 'Receptive Actions',
  category: 'Receptive',
  description: 'Hear a verb and tap the action picture.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'jump', answer: '🤸 jump' },
      { say: 'run', answer: '🏃 run' },
      { say: 'eat', answer: '🍽 eat' },
      { say: 'sleep', answer: '😴 sleep' },
      { say: 'swim', answer: '🏊 swim' },
      { say: 'sit', answer: '🪑 sit' },
      { say: 'drink', answer: '🥤 drink' },
      { say: 'dance', answer: '💃 dance' },
    ],
  },
};
